import { createSlice } from "@reduxjs/toolkit";
import { approveOrRejectRequest, getRequestById, getStudentRegistrationRequests, getStudentRegistrationRequestsByCoordinator } from "./studentRegistrationService";

const initialState = {
  registrationRequests: {
    isDataLoading: null,
    isDataLoaded: null,
    message: null,
    pageCount: 0,
    regRequests: null,
    success: null,
  },
  selectedRequest: {
    isDataLoading: null,
    isDataLoaded: null,
    message: null,
    selectedRequest: null,
    success: null,
  },
  approveOrRejectRequest: {
    isDataLoading: null,
    isDataLoaded: null,
    message: null,
    success: null,
  },
  coordinatorRegistrationRequests: {
    isDataLoading: null,
    isDataLoaded: null,
    message: null,
    pageCount: 0,
    regRequests: null,
    success: null,
  },
};

const studentRegRequests = createSlice({
  name: "studentRegistration",
  initialState,
  reducers: {
    clearMessages: (state) => {
      state.approveOrRejectRequest.message = null;
      state.approveOrRejectRequest.success = null;
    },
  },
  extraReducers: (builder) => {

    builder.addCase(getStudentRegistrationRequests.pending, (state) => {
      state.registrationRequests = {
        ...initialState.registrationRequests,
        isDataLoading: true,
        isDataLoaded: false,
        message: "Loading",
        success: null,
      };
    });

    builder.addCase(getStudentRegistrationRequests.rejected, (state, action) => {
      state.registrationRequests = {
        ...initialState.registrationRequests,
        isDataLoading: false,
        isDataLoaded: false,
        message: action.payload || "Error occurred while getting registration requests",
        success: false,
      };
    });

    builder.addCase(getStudentRegistrationRequests.fulfilled, (state, action) => {
      state.registrationRequests = {
        ...initialState.registrationRequests,
        isDataLoading: false,
        isDataLoaded: true,
        pageCount: action.payload.pageCount || 0,
        regRequests: action.payload.data,
        success: true,
      };
    });

    builder.addCase(getRequestById.pending, (state) => {
      state.selectedRequest = {
        ...initialState.selectedRequest,
        isDataLoading: true,
        isDataLoaded: false,
        message: "Loading",
        success: null,
      };
    });

    builder.addCase(getRequestById.rejected, (state, action) => {
      state.selectedRequest = {
        ...initialState.selectedRequest,
        isDataLoading: false,
        isDataLoaded: false,
        message: action.payload || "Error occurred while getting request",
        success: false,
      };
    });

    builder.addCase(getRequestById.fulfilled, (state, action) => {
      state.selectedRequest = {
        ...initialState.selectedRequest,
        isDataLoading: false,
        isDataLoaded: true,
        selectedRequest: action.payload,
        success: true,
      };
    });

    builder.addCase(approveOrRejectRequest.pending, (state) => {
      state.approveOrRejectRequest = {
        ...initialState.approveOrRejectRequest,
        isDataLoading: true,
        isDataLoaded: false,
        message: "Loading",
        success: null,
      };
    });

    builder.addCase(approveOrRejectRequest.rejected, (state, action) => {
      state.approveOrRejectRequest = {
        ...initialState.approveOrRejectRequest,
        isDataLoading: false,
        isDataLoaded: false,
        message: action.payload.message || "Error occurred while updating request status",
        success: false,
      };
    });

    builder.addCase(approveOrRejectRequest.fulfilled, (state, action) => {
      state.approveOrRejectRequest = {
        ...initialState.approveOrRejectRequest,
        isDataLoading: false,
        isDataLoaded: true,
        message: action.payload.message,
        success: action.payload.success,
      };
    });

    // Coordinator
    builder.addCase(getStudentRegistrationRequestsByCoordinator.pending, (state) => {
      state.coordinatorRegistrationRequests = {
        ...initialState.coordinatorRegistrationRequests,
        isDataLoading: true,
        isDataLoaded: false,
        message: "Loading",
        success: null,
      };
    });

    builder.addCase(getStudentRegistrationRequestsByCoordinator.rejected, (state, action) => {
      state.coordinatorRegistrationRequests = {
        ...initialState.coordinatorRegistrationRequests,
        isDataLoading: false,
        isDataLoaded: false,
        message: action.payload || "Error occurred while getting registration requests",
        success: false,
      };
    });

    builder.addCase(getStudentRegistrationRequestsByCoordinator.fulfilled, (state, action) => {
      state.coordinatorRegistrationRequests = {
        ...initialState.coordinatorRegistrationRequests,
        isDataLoading: false,
        isDataLoaded: true,
        pageCount: action.payload.pageCount || 0,
        regRequests: action.payload.data,
        success: true,
      };
    });
  },
});

export const { setSelectedRequest, clearSelectedRequest, clearMessages } = studentRegRequests.actions;

export default studentRegRequests.reducer;